import gql from 'graphql-tag'
export const fetchRemoveFreeBeerToCartMutation = gql(`
mutation ($item_id: Int, $id: Int , $product_id: Int ,$operate_flag: String!) {
    freeBeerCart(
        input:{
            item_id: $item_id,
            id: $id,
            product_id: $product_id,
            operate_flag: $operate_flag
        }
    ){
        success_message
        error_message
        iFreebeerProductCartQty
        iFillUpLayerQty
        item_id
    }
}`)
